<button #btn class="dropdown-item">
  <ng-content></ng-content>
</button>
